import { render, staticRenderFns } from "./ScreenPedidosArchivos.vue?vue&type=template&id=5fdd6167&scoped=true"
import script from "./ScreenPedidosArchivos.vue?vue&type=script&lang=js"
export * from "./ScreenPedidosArchivos.vue?vue&type=script&lang=js"
import style0 from "./ScreenPedidosArchivos.vue?vue&type=style&index=0&id=5fdd6167&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd6167",
  null
  
)

export default component.exports